/**
 * Verification Form Handler
 * Handles OTP/verification code input with auto-focus and validation
 */
export function initVerifyForm() {
	// Check if verify form exists on this page
	const verifyForm = document.getElementById('verify-form');
	if (!verifyForm) return;

	const inputs = document.querySelectorAll('.verify-input');
	const submitBtn = document.getElementById('verify-btn');
	const countdownEl = document.getElementById('countdown');

	// Early return if required elements don't exist
	if (!inputs.length || !submitBtn) return;

	/**
	 * Check if all verification inputs are filled
	 * Enable/disable submit button accordingly
	 */
	function checkAllFilled() {
		const allFilled = Array.from(inputs).every(input => input.value.length === 1);

		if (allFilled) {
			submitBtn.disabled = false;
			submitBtn.classList.remove('opacity-50', 'cursor-not-allowed');
		} else {
			submitBtn.disabled = true;
			submitBtn.classList.add('opacity-50', 'cursor-not-allowed');
		}
	}

	/**
	 * Initialize verification input handlers
	 */
	inputs.forEach((input, index) => {
		// Handle input - only allow numbers and auto-focus next
		input.addEventListener('input', function(e) {
			// Only allow numbers
			this.value = this.value.replace(/[^0-9]/g, '');

			// Auto-focus next input when current is filled
			if (this.value.length === 1 && index < inputs.length - 1) {
				inputs[index + 1].focus();
			}

			// Check if all inputs are filled
			checkAllFilled();
		});

		// Handle backspace - go to previous input
		input.addEventListener('keydown', function(e) {
			if (e.key === 'Backspace' && !this.value && index > 0) {
				inputs[index - 1].focus();
				// Recheck after backspace
				setTimeout(checkAllFilled, 10);
			}
		});

		// Handle paste - distribute pasted content across inputs
		input.addEventListener('paste', (e) => {
			e.preventDefault();
			const pastedData = e.clipboardData.getData('text').replace(/[^0-9]/g, '');

			// Distribute pasted digits across inputs
			for (let i = 0; i < pastedData.length && index + i < inputs.length; i++) {
				inputs[index + i].value = pastedData[i];
			}

			// Focus the next empty input or last input
			const nextEmptyIndex = Array.from(inputs).findIndex(inp => !inp.value);
			if (nextEmptyIndex !== -1) {
				inputs[nextEmptyIndex].focus();
			} else {
				inputs[inputs.length - 1].focus();
			}

			checkAllFilled();
		});
	});

	// Auto-focus first input on page load
	if (inputs.length > 0) {
		inputs[0].focus();
	}

	/**
	 * Countdown timer for verification code expiration
	 */
	if (countdownEl) {
		let timeLeft = 240; // 4:00 in seconds

		const updateCountdown = () => {
			const minutes = Math.floor(timeLeft / 60);
			const seconds = timeLeft % 60;
			countdownEl.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

			if (timeLeft > 0) {
				timeLeft--;
				setTimeout(updateCountdown, 1000);
			} else {
				countdownEl.textContent = '00:00';
				// Optionally disable form when expired
				submitBtn.disabled = true;
				submitBtn.classList.add('opacity-50', 'cursor-not-allowed');
			}
		};

		updateCountdown();
	}
}
